import styled from '@emotion/styled'

import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { BodyM } from '@/components/Typography'

const CarouselButtonsStyles = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 'var(--space-2)',
  paddingBottom: 'var(--space-2)',

  '& .carousel-button': {
    paddingRight: 'var(--space-2)',
    paddingLeft: 'var(--space-2)',
    minWidth: 'auto',
    borderRadius: 'var(--radii-default)',
  },
})

const CarouselLegend = styled.div({
  paddingRight: 'var(--space-3)',
  paddingLeft: 'var(--space-3)',
})

export interface CarouselButtonsProps {
  onNext: (event?: Event) => void
  onPrev: (event?: Event) => void
  onActive: (index: number) => void
  currentSlide: number
  totalSlides: number
  colorModifier?: 'primary' | 'snow'
}

export const DefaultCarouselButtons = ({
  onNext,
  onPrev,
  currentSlide,
  totalSlides,
  colorModifier = 'primary',
}: CarouselButtonsProps) => {
  const legendColor = colorModifier === 'snow' ? 'light-high' : colorModifier

  return (
    <CarouselButtonsStyles>
      <Button
        className="carousel-button"
        size="lg"
        modifier="outline"
        onClick={onPrev}
        aria-label="Slide anterior"
      >
        <Icon color={colorModifier} icon="angle-left" />
      </Button>

      <CarouselLegend>
        <BodyM color={legendColor} dark="medium">{`${currentSlide} de ${totalSlides}`}</BodyM>
      </CarouselLegend>

      <Button
        className="carousel-button"
        size="lg"
        modifier="outline"
        onClick={onNext}
        aria-label="Próximo slide"
        type="button"
      >
        <Icon color={colorModifier} icon="angle-right" />
      </Button>
    </CarouselButtonsStyles>
  )
}

export default DefaultCarouselButtons
